import { render, staticRenderFns } from "./FormDataPass.vue?vue&type=template&id=5fa24f28&scoped=true"
import script from "./FormDataPass.vue?vue&type=script&lang=js"
export * from "./FormDataPass.vue?vue&type=script&lang=js"
import style0 from "./FormDataPass.vue?vue&type=style&index=0&id=5fa24f28&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fa24f28",
  null
  
)

export default component.exports